import { BaseDashboardActionItem, LoadableTypography } from '@uplift/ui-v2';
import React from 'react';
import { DrawOutlined } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { useHistory } from 'react-router';
import { ROUTING_CONFIG } from '@uplift/constants';
import { useStatesQuery } from '@uplift/queries';


type UnsignedCollaborativeAgreementsProps = {
  stateIds: string[];
};


const UnsignedCollaborativeAgreementsContent: React.VFC<UnsignedCollaborativeAgreementsProps> = (props) => {
  const history = useHistory();
  const { data: states } = useStatesQuery({ suspense: true });
  const stateNames = props.stateIds.map((stateId) => states?.find((state) => state.id === stateId)?.fullName).filter(Boolean);

  return (
    <BaseDashboardActionItem
      title={<Typography>Sign <b>{props.stateIds.length}</b> Collaborative Practice Agreements</Typography>}
      body={<Typography variant="body2" sx={{ mt: -1 }}>{stateNames.join(', ')}</Typography>}
      color="danger"
      icon={<DrawOutlined />}
      action={{
        handleClick: () => {
          history.push(ROUTING_CONFIG.documentsCenter);
        },
        text: 'Review & Sign'
      }}
    />
  );
};


export const UnsignedCollaborativeAgreements: React.VFC<UnsignedCollaborativeAgreementsProps> = (props) => {
  return (
    <React.Suspense
      fallback={(
        <BaseDashboardActionItem
          title={<LoadableTypography width="400px" />}
          body={<Box sx={{ mt: -1 }}><LoadableTypography variant="body2" width="400px" /></Box>}
          color="danger"
          icon={<DrawOutlined />}
        />
      )}
    >
      <UnsignedCollaborativeAgreementsContent stateIds={props.stateIds} />
    </React.Suspense>
  );
};
